import { useActivateCustomer } from 'hooks';
import { getResourceImage, getResourceText } from 'lib/resources';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import { isString } from 'underscore';
import AccountWrapper from './account-wrapper';
import { PREFIX as accountSlug } from '../dashboard/slugs';

const Activate = ({
  page: {
    resources: { global, access },
  },
}) => {
  const {
    query: { id, token },
  } = useRouter();

  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  const { activate, loading, error } = useActivateCustomer(id, token);

  const tGlobal = getResourceText(global);
  const t = getResourceText(access);

  const errorText = tGlobal('Server error text', 'Something went wrong, please try again later.');
  const loadingButtonText = tGlobal('Button loading text', 'Loading...');
  const buttonText = t('Activate submit button text', 'Activate');
  const passwordLabel = t('New password label', 'New password');
  const passwordConfirmLabel = t('Confirm new password label', 'Confirm new password');

  return (
    <AccountWrapper backgroundImage={getResourceImage(access)('Background image')}>
      <form
        onSubmit={e => {
          e.preventDefault();
          activate(passwordRef.current.value, passwordConfirmRef.current.value);
        }}
        className="flex w-full flex-col gap-7 md:gap-9"
      >
        <h2 className="font-nimbus-sans-extd-d text-[2.5rem] font-bold uppercase leading-[85%] tracking-[-0.02em] text-blue">
          {t('Activate title', 'Activate account')}
        </h2>
        <div className="flex flex-col gap-2">
          <label htmlFor="password">
            <input
              ref={passwordRef}
              name="password"
              type="password"
              required
              placeholder={passwordLabel}
              className="input text-body-1 w-full"
            />
          </label>
          <label htmlFor="passwordConfirm">
            <input
              ref={passwordConfirmRef}
              name="passwordConfirm"
              type="password"
              id="passwordConfirm"
              required
              placeholder={passwordConfirmLabel}
              className="input text-body-1 w-full"
            />
          </label>
        </div>
        <div>
          <button type="submit" className="button w-full">
            {loading ? loadingButtonText : buttonText}
          </button>
          {error && (
            <p className="text-red-500 mt-[5px] text-[12px]">
              {isString(error) ? error : errorText}
            </p>
          )}
        </div>
        <a href={`${accountSlug}/login/`} className="text-body-2 underline">
          {t('Back to Log In Text')}
        </a>
      </form>
    </AccountWrapper>
  );
};
export default Activate;
